<template>
  <div>
    <el-dialog
      v-el-drag-dialog
      :visible.sync="innerVisible"
      :title="$t('SeaExport.BatchSend') + 'LTS'"
      width="1000px"
      :close-on-click-modal="false"
    >
      <div style="flex-grow:1;display:flex;flex-direction:column;text-align: center;">
        <el-form label-position="left" label-width="90px">
          <el-row :gutter="10">
            <el-col :span="7">
              <el-form-item :label="$t('SeaExport.AccountObject')">
                <cargo-company-select
                  :method-params="{ active: true }"
                  :check-credit="false"
                  :default-value="ltsSyncDialog.accountId||''"
                  @change="p=>{ltsSyncDialog.accountId=p.value}"
                />
              </el-form-item>
            </el-col>
            <el-col :span="7">
              <el-form-item :label="$t('SeaExport.Currency')">
                <cargo-advance-select
                  filterable
                  :select-type="selectTypeNames.basic_data_Currency"
                  :default-value="ltsSyncDialog.currency || ''"
                  options-width="100px"
                  @parentCallBack="p=>{ltsSyncDialog.currency=p.value}"
                />
              </el-form-item>
            </el-col>
            <el-col :span="3">
              <el-form-item label-width="0">
                <el-button type="primary" @click="searchChargeHandler">{{ $t('common.btn.query') }}</el-button>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <cargo-ag-grid
        config-module="1300011"
        :grid-options="ltsSyncDialog.gridOptions"
        :column-defs="ltsSyncDialog.columnDefs"
        :row-data="ltsSyncDialog.rowData"
        :grid-params.sync="ltsSyncDialog.gridParams"
        :check-main-record="false"
        :deselect-main-record="false"
        style="margin-top: 10px;height: 400px;"
        @gridReady="params=>ltsSyncDialog.gridApi=params.api"
      />
      <div slot="footer">
        <el-button type="primary" @click="confirmLtsSync">{{ $t('common.btn.confirm') }}</el-button>
        <el-button @click="innerVisible=false">{{ $t('common.btn.cancel') }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>

import cargoCompanySelect from '@/components/Cargo/Common/cargoCompanySelect'
import CargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import ColumnUtils from '@/utils/ColumnUtils'
import { formatNumberToThousands } from '@/utils'
import * as ChargeConstants from '@/class/cargo/model/parameters/ChargeConstants'
const { getLoading4Cxt } = require('@/utils/utilBaseElement')
const { sleep, ensureExecuteSuccess } = require('@/utils/commonUtil')
const { batchPushLtsFunc, queryLtsChargeFunc } = require('@/api/clearing/charge')

export default {
  name: 'LtsBatchSync',
  components: {
    cargoCompanySelect,
    CargoAdvanceSelect
  },
  props: {
    visible: { type: Boolean, required: true },
    keys: { type: Array, required: true }
  },
  data() {
    return {
      ChargeConstants,
      selectTypeNames: TYPE_NAMES,
      loading: false,
      innerVisible: false,
      ltsSyncDialog: {
        accountId: 0,
        currency: null,
        gridApi: null,
        gridParams: {},
        gridOptions: {
          rowSelection: 'multiple',
          suppressRowClickSelection: true, // 如果为true， 则单击行时不会发生行选择。当您想要专门选择复选框时使用。
          treeData: true,
          groupDefaultExpanded: 2,
          getDataPath: data => {
            return data.path ? data.path.split(',') : ''
          },
          autoGroupColumnDef: {
            headerName: this.$t('SeaExport.BusinessNo'),
            colId: 'jobNo',
            field: 'jobNo',
            width: 240,
            headerCheckboxSelection: true,
            headerCheckboxSelectionFilteredOnly: true,
            cellRendererParams: {
              suppressCount: true,
              suppressDoubleClickExpand: true,
              checkbox: params => {
                return true
              }
            }
          }
        },
        columnDefs: [
          {
            headerName: this.$t('CargoMsg.Cargo_SettleAccountsTo'), field: 'accountId', width: 180,
            valueFormatter: (params) => {
              if (!params.data || !params.data.chargeUuid) return ''
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'chineseName')
            }
          },
          {
            headerName: this.$t('CargoMsg.Cargo_ChargeName'), field: 'chargeItemId', width: 100,
            valueFormatter: (params) => {
              if (!params.data || !params.data.chargeUuid) return ''
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_ChargeItem, 'itemId', params.value, 'zhName')
            }
          },
          {
            headerName: this.$t('CargoMsg.Cargo_TaxIncludedPrice'), field: 'amount', width: 100,
            valueFormatter: (params) => {
              if (!params.data || !params.data.chargeUuid) return ''
              return formatNumberToThousands(ColumnUtils.number2ColumnLabelFunc(params.value), 2)
            }
          },
          { headerName: this.$t('CargoMsg.Cargo_Currency'), field: 'currency', width: 80 },
          {
            headerName: this.$t('CargoMsg.Cargo_ExchangeRate2'), field: 'rate', width: 80,
            valueFormatter: (params) => {
              if (!params.data || !params.data.chargeUuid) return ''
              return ColumnUtils.formatNumber(params.value, 8)
            }
          },
          {
            headerName: this.$t('CargoMsg.Cargo_UnitPrice'), field: 'unitRate', width: 80,
            valueFormatter: (params) => {
              if (!params.data || !params.data.chargeUuid) return ''
              return formatNumberToThousands(ColumnUtils.number2ColumnLabelFunc(params.value), 2)
            }
          },
          {
            headerName: this.$t('CargoMsg.Cargo_AmountNumber'), field: 'quantity', width: 80,
            valueFormatter: (params) => {
              if (!params.data || !params.data.chargeUuid) return ''
              return formatNumberToThousands(ColumnUtils.number2ColumnLabelFunc(params.value), 2)
            }
          },
          {
            headerName: this.$t('Invoice.invoice_domesticOrInternational'), field: 'oversea', width: 100, hide: true,
            valueFormatter: (params) => {
              if (!params.data || !params.data.chargeUuid) return ''
              return ColumnUtils.overseaLabelFunc(params.value)
            }
          },
          {
            headerName: this.$t('CargoMsg.Cargo_Unit'), field: 'measure', width: 80, hide: true,
            valueFormatter: (params) => {
              if (!params.data || !params.data.chargeUuid) return ''
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_ChargeUnit, 'code', params.value, 'chineseName')
            }
          },
          {
            headerName: this.$t('CargoMsg.Cargo_TaxExcludedPrice'), field: 'excludingTaxAmount', width: 100, hide: true,
            valueFormatter: (params) => {
              if (!params.data || !params.data.chargeUuid) return ''
              return formatNumberToThousands(ColumnUtils.number2ColumnLabelFunc(params.value), 2)
            }
          },
          {
            headerName: this.$t('CargoMsg.Cargo_TaxRate'), field: 'taxRate', width: 80, hide: true,
            valueFormatter: (params) => {
              if (!params.data || !params.data.chargeUuid) return ''
              return params.value
            }
          },
          {
            headerName: this.$t('CargoMsg.Cargo_TaxAmount'), field: 'taxAmount', width: 100, hide: true,
            valueFormatter: (params) => {
              if (!params.data || !params.data.chargeUuid) return ''
              return formatNumberToThousands(ColumnUtils.number2ColumnLabelFunc(params.value), 2)
            }
          }
        ],
        rowData: [], // 列表显示数据
        rowDataBak: [] // 每次进弹窗时的总数据,作用是留着当前页面查询使用
      }
    }
  },
  watch: {
    visible(newVal) {
      this.innerVisible = newVal
    },
    innerVisible(newVal) {
      if (!newVal) {
        this.ltsSyncDialog.rowData = this.ltsSyncDialog.rowDataBak = []
      }
      this.$emit('update:visible', newVal)
    }
  },
  methods: {
    async onShow(data) {
      if (!data) {
        return
      }
      const params = {}
      params.keys = Array.from(data.rows, p => p.uuid)
      switch (data.anyBool) {
        case 1:
          params.anyBool = true
          break
        case 2:
          params.anyBool = false
          break
      }
      this.loading = getLoading4Cxt(this)
      await queryLtsChargeFunc(params).then(res => {
        this.ltsSyncDialog.rowData = this.ltsSyncDialog.rowDataBak = res.data
        this.ltsSyncSelectAll()
      }).finally(() => {
        this.loading.close()
      })
    },
    confirmLtsSync() {
      if (!this.ltsSyncDialog.gridApi) return
      const rows = this.ltsSyncDialog.gridApi.getSelectedRows()
      if (!rows || rows.length <= 0) {
        this.$message.warning(this.$t('Message.PleaseSelectTheFeeYouNeedToPush'))
        return
      }
      const useRows = []
      for (const row of rows) {
        useRows.push(row.chargeUuid)
      }
      this.loading = getLoading4Cxt(this)
      batchPushLtsFunc(useRows).then(res => {
        if (res.data === 'ok') {
          this.$message.success(this.$t('Message.SynchronizationSucceeded'))
        } else if (res.data === 'not data') {
          this.$message.warning(this.$t('Message.NoSynchronizationContent'))
        } else {
          this.$message.warning(res.data)
        }
      }).finally(() => {
        this.innerVisible = false
        this.loading.close()
      })
    },
    searchChargeHandler() {
      if (!this.ltsSyncDialog.rowDataBak) this.ltsSyncDialog.rowData = []
      const tempData = []
      const jobNos = []
      // 这里循环出所有满足条件的费用【二级数据】
      for (const temp of this.ltsSyncDialog.rowDataBak) {
        if (!temp.chargeUuid) continue
        const isYes = !this.ltsSyncDialog.accountId && !this.ltsSyncDialog.currency
        let haveParams = true
        if (!isYes) {
          if (this.ltsSyncDialog.accountId && this.ltsSyncDialog.accountId > 0) {
            haveParams = (temp.accountId === this.ltsSyncDialog.accountId)
          }
          if (haveParams && this.ltsSyncDialog.currency) {
            haveParams = (temp.currency === this.ltsSyncDialog.currency)
          }
        }
        if (isYes || haveParams) {
          if (!jobNos.includes(temp.jobNo)) {
            jobNos.push(temp.jobNo)
          }
          tempData.push(temp)
        }
      }
      // 这里拼接父级数据
      for (const tempPt of this.ltsSyncDialog.rowDataBak) {
        if (!tempPt.chargeUuid && jobNos.includes(tempPt.jobNo)) {
          tempData.push(tempPt)
        }
      }
      this.ltsSyncDialog.rowData = tempData || []
      this.ltsSyncSelectAll()
    },
    ltsSyncSelectAll() {
      this.$nextTick(async() => {
        if (this.ltsSyncDialog.gridApi) {
          await sleep(100)
        } else {
          // 等待gridApi被赋值
          await ensureExecuteSuccess(() => this.ltsSyncDialog.gridApi)
        }
        this.ltsSyncDialog.gridApi.selectAll()
      })
    }
  }
}
</script>
<style scoped>

ul li {
  list-style: none;
  font-size: 13px;
  color: #909399;
}

</style>

